// dropdown/DropdownMenu.js
import React, {useState} from 'react';
import "./burgermenu.css"


const BurgerMenu  : React.FC<({clicked: boolean})> = props => {

    // const [clicked, setClicked] = useState(false);
    // const handleClick = () => setClicked(!clicked);



    return (
        <div className={`burger ${props.clicked ? 'active_burger' : ''}`} >
            <span></span>
        </div>
    );
};

export default BurgerMenu;
